import { Button, Slider, Stack, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { SpeechResult } from './AIResult/SpeechResult';
import { SpeechAssessment } from './OnDeviceResult/SpeechAssessment';
import axios from '../../util/Axios';

function createAudioRange(audio) {
  return [audio.info?.start, audio.info?.start + audio.info?.duration];
}

export function Audio({ model1Result, speechAssessment, test }) {

  const testId = test.uuid;

  const [audioFiles, setAudioFiles] = useState([]);
  const [range, setRange] = useState([]);

  useEffect(() => {

    const controller = new AbortController();
    const signal = controller.signal;

    const fetchData = async () => {
      const audios = new Array(6).fill({ file: '', info: {} });
      const promises = [];

      for (let index = 0; index < 6; index++) {
        promises.push(axios(`/strokeTests/${testId}/audio/${index}`, { responseType: 'blob', signal }));
      }

      const results = await Promise.allSettled(promises);

      results.forEach((result, index) => {
        if (result.status === 'fulfilled') {
          audios[index] = {
            file: window.URL.createObjectURL(result.value.data),
            info: test.audioFiles ? test.audioFiles[index] : {},
          };
        } else {
          console.log(`Failed to fetch audio ${index}:`, result.reason);
        }
      });

      setRange(audios.map(a => createAudioRange(a)));
      setAudioFiles(audios);
    };

    fetchData();

    return () => controller.abort();
  }, [testId, test.audioFiles]);

  const updateAudio = async (index, range) => {

    try {
      await axios.post(`strokeTests/${testId}/audio/${index}/extract`, {
        start: range[0],
        end: range[1],
      });
    } catch (err) {
      console.log("Failed to update audio:", err);
      return;
    }

    const audioPromise = axios.get(`/strokeTests/${testId}/audio/${index}`, { responseType: 'blob' });
    const detailsPromise = axios.get(`/strokeTests/${testId}/details`);

    const [audioResult, detailsResult] = await Promise.allSettled([audioPromise, detailsPromise]);
    const updatedAudios = [...audioFiles];

    if (audioResult.status === 'fulfilled' && detailsResult.status === 'fulfilled') {
      updatedAudios[index] = {
        file: window.URL.createObjectURL(audioResult.value.data),
        info: detailsResult.value.data.audioFiles[index]
      }
    } else {
      console.log(`Failed to fetch audio details for audio ${index}`);
    }

    setAudioFiles(updatedAudios);
  };

  const handleSliderChange = (index) => (event, newValue) => {
    const newRanges = [...range];
    newRanges[index] = newValue;
    setRange(newRanges);
  };

  return (
    <>
      <Stack>
        {audioFiles.map((audioItem, index) => (
          <Box key={index}>
            <Typography>{audioItem.info?.tagName}</Typography>
            <ReactPlayer style={{ margin: 'auto' }} height="20px" width="795px" controls={true} url={audioItem.file} />
            <Stack direction="row" spacing={2}>
              <Slider step={0.5} valueLabelDisplay="auto" value={range[index]} onChange={handleSliderChange(index)} />
              <Button onClick={() => updateAudio(index, range[index])}>Update</Button>
            </Stack>
          </Box>
        ))}
        {model1Result ? <SpeechResult model1Result={model1Result} title="FAST AI Score" /> : null}
        {speechAssessment ? <SpeechAssessment speechDetails={speechAssessment} /> : null}
      </Stack>
    </>
  );
}
